export default "__VITE_ASSET__BlXu2mH3__"